RivalIQ.apps.Share.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.CreateAccount = Backbone.Model.extend({
        url: '/api/createAccountFromLandscape'
    });

});
